import React from "react";
import {Container, Grid} from "@material-ui/core";
import Page from "../../components/Page";
import CreateCustomerView from "./CreateCustomerView";
import CustomerTable from "./CustomerTable";
import {HasRole} from "../../common/Util";
import {RoleIdEnum} from "../../generated/graphql";

export default () => {
    return (
        <Page title={"user page"}>
            <Container maxWidth={false} style={{ padding: "30px"}}>
                <Grid container spacing={2}>
                    <CreateCustomerView/>
                    <CustomerTable/>
                </Grid>
            </Container>
        </Page>
    )
}